/* eslint-disable sort-keys */
import {ROUTER_QUERY_TAG_OR_COLLECTION_KEY} from 'plugins/modules/filter/constants';
import {ROUTER_QUERY_KEY} from 'modules/router/constants';
import {NEXT_PUBLIC_MASTER_HOST} from 'core/helpers/env';

export const APP_ROUTES_KEYS = {
    main: 'main',
    catalog: 'catalog',
    search: 'search',
    articles: 'articles',
    events: 'events',
    addresses: 'addresses',
    about: 'about',
    feedback: 'feedback',
    loyalty: 'loyalty',
    prive: 'prive',
    corp: 'corp',
    rent: 'rent',
    privacy: 'privacy',
    terms: 'terms',
    stock: 'stock',
    certificate: 'certificate',
    brands: 'brands',
    personal: 'personal',
    product: 'product',
    productReviews: 'productReviews',
    checkout: 'checkout',
    refferal: 'refferal',
    programRules: 'programRules',
    services: 'services',
    franchise: 'franchise',
    gift: 'gift',
    careers: 'careers',
    wishlist: 'wishlist',
} as const;

export const CATALOG_ROUTES_KEYS = {
    wine: 'wine',
    sparkling: 'sparkling',
    strong: 'strong',
    wiskey: 'wiskey',
    kogniak: 'kogniak',
    water: 'water',
    glasses: 'glasses',
    accessories: 'accessories',
    collection: 'collection',
} as const;

export const STOCK_ROUTES_KEYS = {
    gift: 'gift',
    discount: 'discount',
    strong: 'strong',
    new: 'new',
    choice: 'choice',
    russian: 'russian',
    stock: 'stock',
} as const;

export const ABOUT_ROUTES_KEYS = {
    contacts: 'contacts',
    howto: 'howto',
    delivery: 'delivery',
    warranty: 'warranty',
} as const;

export const PRIVATE_ROUTE_KEY = {
    personal: 'personal',
} as const;

export const PRIVATE_ROUTES_KEYS = {
    lk: 'lk',
    favorites: 'favorites',
    offers: 'offers',
    history: 'history',
    settings: 'settings',
    inviteFriend: 'inviteFriend',
} as const;

export const CART_ROUTE_KEY = {
    cart: 'cart',
} as const;

export const APP_ROUTES = {
    [APP_ROUTES_KEYS.main]: 'main',
    [APP_ROUTES_KEYS.catalog]: 'catalog',
    [APP_ROUTES_KEYS.articles]: 'articles',
    [APP_ROUTES_KEYS.events]: 'events',
    [APP_ROUTES_KEYS.addresses]: 'nashi-vinoteki',
    [APP_ROUTES_KEYS.about]: 'about',
    [APP_ROUTES_KEYS.feedback]: 'feedback',
    [APP_ROUTES_KEYS.loyalty]: 'loyalty',
    [APP_ROUTES_KEYS.prive]: 'prive',
    [APP_ROUTES_KEYS.corp]: 'corp',
    [APP_ROUTES_KEYS.rent]: 'rent',
    [APP_ROUTES_KEYS.privacy]: 'privacy_policy',
    [APP_ROUTES_KEYS.terms]: 'terms',
    [APP_ROUTES_KEYS.stock]: 'stock',
    [APP_ROUTES_KEYS.certificate]: 'certificate',
    [APP_ROUTES_KEYS.brands]: 'brands',
    [APP_ROUTES_KEYS.personal]: 'personal',
    [APP_ROUTES_KEYS.refferal]: 'refferal',
    [APP_ROUTES_KEYS.programRules]: 'programrules',
    [APP_ROUTES_KEYS.services]: 'services',
    [APP_ROUTES_KEYS.franchise]: 'franchise',
    [APP_ROUTES_KEYS.gift]: 'gift',
    [APP_ROUTES_KEYS.careers]: 'careers',
} as const;

export const APP_SINGLE_PAGE_ROUTES = [
    APP_ROUTES_KEYS.main,
    APP_ROUTES_KEYS.about,
    APP_ROUTES_KEYS.feedback,
    APP_ROUTES_KEYS.loyalty,
    APP_ROUTES_KEYS.corp,
    APP_ROUTES_KEYS.rent,
    APP_ROUTES_KEYS.privacy,
    APP_ROUTES_KEYS.terms,
    APP_ROUTES_KEYS.refferal,
    APP_ROUTES_KEYS.programRules,
] as const;

export const CATALOG_ROUTES = {
    [CATALOG_ROUTES_KEYS.wine]: 'vino',
    [CATALOG_ROUTES_KEYS.sparkling]: 'shampanskoe-i-igristoe-vino',
    [CATALOG_ROUTES_KEYS.strong]: 'ksn',
    [CATALOG_ROUTES_KEYS.wiskey]: 'viski',
    [CATALOG_ROUTES_KEYS.kogniak]: 'koniak',
    [CATALOG_ROUTES_KEYS.water]: 'voda-i-soki',
    [CATALOG_ROUTES_KEYS.glasses]: 'bokaly',
    [CATALOG_ROUTES_KEYS.accessories]: 'aksessuary',
    [CATALOG_ROUTES_KEYS.collection]: 'simple-collection',
} as const;

export const STOCK_ROUTES = {
    [APP_ROUTES_KEYS.stock]: 'stock',
    [STOCK_ROUTES_KEYS.discount]: 'discount',
    [STOCK_ROUTES_KEYS.new]: 'novinki',
} as const;

export const ABOUT_ROUTES = {
    [ABOUT_ROUTES_KEYS.contacts]: 'contacts',
    [ABOUT_ROUTES_KEYS.howto]: 'howto',
    [ABOUT_ROUTES_KEYS.delivery]: 'delivery',
    [ABOUT_ROUTES_KEYS.warranty]: 'warranty',
} as const;

export const APP_ROUTES_TO_URL = {
    [APP_ROUTES_KEYS.main]: '/',
    [APP_ROUTES_KEYS.catalog]: '/catalog',
    [APP_ROUTES_KEYS.search]: '/search',
    [APP_ROUTES_KEYS.articles]: '/articles',
    [APP_ROUTES_KEYS.events]: '/events',
    [APP_ROUTES_KEYS.addresses]: '/nashi-vinoteki',
    [APP_ROUTES_KEYS.about]: '/about',
    [APP_ROUTES_KEYS.feedback]: '/feedback',
    [APP_ROUTES_KEYS.loyalty]: '/loyalty',
    [APP_ROUTES_KEYS.prive]: '/prive',
    [APP_ROUTES_KEYS.corp]: '/corp',
    [APP_ROUTES_KEYS.rent]: '/rent',
    [APP_ROUTES_KEYS.privacy]: '/privacy_policy',
    [APP_ROUTES_KEYS.terms]: '/terms',
    [APP_ROUTES_KEYS.stock]: '/stock',
    [APP_ROUTES_KEYS.certificate]: '/certificate',
    [APP_ROUTES_KEYS.brands]: '/brands',
    [APP_ROUTES_KEYS.personal]: '/personal',
    [APP_ROUTES_KEYS.refferal]: '/refferral',
    [APP_ROUTES_KEYS.programRules]: '/programrules',
    [APP_ROUTES_KEYS.services]: '/services',
    [APP_ROUTES_KEYS.franchise]: `/services/franchise/`,
    [APP_ROUTES_KEYS.gift]: '/articles/news/podarochnyy-sertifikat-simple-kak-eto-rabotaet/',
    [APP_ROUTES_KEYS.careers]:
        'https://careers.simple.ru/?utm_source=site&utm_medium=banner&utm_campaign=Simplewine.ru',
    [APP_ROUTES_KEYS.wishlist]: '/wishlist',
} as const;

export const CATALOG_ROUTES_TO_URL = {
    [CATALOG_ROUTES_KEYS.wine]: `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/${CATALOG_ROUTES.wine}`,
    [CATALOG_ROUTES_KEYS.sparkling]: `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/${CATALOG_ROUTES.sparkling}`,
    [CATALOG_ROUTES_KEYS.strong]: `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/${CATALOG_ROUTES.strong}`,
    [CATALOG_ROUTES_KEYS.wiskey]: `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/${
        CATALOG_ROUTES[CATALOG_ROUTES_KEYS.strong]
    }/${CATALOG_ROUTES_KEYS.wiskey}`,
    [CATALOG_ROUTES_KEYS.kogniak]: `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/${
        CATALOG_ROUTES[CATALOG_ROUTES_KEYS.strong]
    }/${CATALOG_ROUTES.kogniak}`,
    [CATALOG_ROUTES_KEYS.water]: `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/${CATALOG_ROUTES.water}`,
    [CATALOG_ROUTES_KEYS.glasses]: `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/${CATALOG_ROUTES.glasses}`,
    [CATALOG_ROUTES_KEYS.accessories]: `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/${CATALOG_ROUTES.accessories}`,
    [CATALOG_ROUTES_KEYS.collection]: `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/${CATALOG_ROUTES.collection}`,
} as const;

export const PRIVATE_ROUTE_BASE_TO_URL = '/personal';

export const PRIVATE_ROUTE_QUERY_PARAM = {
    [APP_ROUTES_KEYS.personal]: 'personal',
    [PRIVATE_ROUTES_KEYS.lk]: 'lk',
    [PRIVATE_ROUTES_KEYS.inviteFriend]: 'invite-a-friend',
    [PRIVATE_ROUTES_KEYS.favorites]: 'favorites',
    [PRIVATE_ROUTES_KEYS.offers]: 'personal-offers',
    [PRIVATE_ROUTES_KEYS.history]: 'orders-history',
    [PRIVATE_ROUTES_KEYS.settings]: 'settings',
} as const;

export const CART_ROUTE_TO_URL = `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.personal]}/${CART_ROUTE_KEY.cart}`;

export const PAGE = {
    list: 'list',
    item: 'item',
} as const;

export const PRODUCT_BASE_ROUTE = `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog]}/product/`;
export const PRODUCT_ROUTES = {
    [APP_ROUTES_KEYS.product]: 'product',
    [APP_ROUTES_KEYS.productReviews]: 'productReviews',
} as const;

export const PROFILE_ROUTES = {
    personal: PRIVATE_ROUTE_BASE_TO_URL,
    profile: `${PRIVATE_ROUTE_BASE_TO_URL}/profile`,
} as const;

export const PROFILE_ROUTES_LIST = Object.values(PROFILE_ROUTES);

export const PROFILE_PAGE_TO_LABEL = {
    [PRIVATE_ROUTES_KEYS.lk]: 'Личные данные',
    [PRIVATE_ROUTES_KEYS.history]: 'История заказов',
    [PRIVATE_ROUTES_KEYS.inviteFriend]: 'Приведи друга',
    [PRIVATE_ROUTES_KEYS.offers]: 'Персональные предложения',
    [PRIVATE_ROUTES_KEYS.favorites]: 'Избранное',
    [PRIVATE_ROUTES_KEYS.settings]: 'Профиль SimpleWine',
} as const;

export const EXCEPTION_PATHS = ['/catalog/category', '/catalog'];

export const CART_PAGE = CART_ROUTE_KEY.cart;
export const CATALOG_PAGE = APP_ROUTES[APP_ROUTES_KEYS.catalog];
export const COOKIES_POLICY_PAGE = 'cookies_policy';
export const SEO_CATALOG_PAGE = 'seo';
export const TERMS_PAGE = APP_ROUTES[APP_ROUTES_KEYS.terms];
export const PERSONAL_DATA_PROCESSING_PAGE = 'consent_to_pd1';
export const PERSONAL_DATA_PROCESSING_PAGE_AUTH = 'consent_to_pd2';
export const PRIVACY_POLICY_PAGE = 'processing_policy';
export const RECOMMENDATION_TECHNOLOGIES_PAGE = 'recommendation_technologies';
export const PRODUCT_PAGE = PRODUCT_ROUTES[APP_ROUTES_KEYS.product];
export const PRODUCT_REVIEWS_PAGE = 'reviews';
export const SEARCH_PAGE = APP_ROUTES_KEYS.search;
export const SERVICE_PAGE = APP_ROUTES[APP_ROUTES_KEYS.services];
export const COLLECTIONS_LIST_PAGE = 'collections';
export const DASHBOARD_PAGE = 'dashboard';
export const WINESHOPS_LIST_PAGE = APP_ROUTES[APP_ROUTES_KEYS.addresses];
export const PERSONAL_PAGE = APP_ROUTES[APP_ROUTES_KEYS.personal];
export const BRANDS_PAGE = APP_ROUTES[APP_ROUTES_KEYS.brands];
export const ARTICLES_PAGE = APP_ROUTES[APP_ROUTES_KEYS.articles];
export const EVENTS_PAGE = APP_ROUTES[APP_ROUTES_KEYS.events];
export const STOCK_PAGE = APP_ROUTES[APP_ROUTES_KEYS.stock];
export const DISCOUNT_PAGE = 'discount';
export const WISHLIST_PAGE = 'wishlist';

export const HOME_ROUTE = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.main];
export const STOCK_ROUTE = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.stock];
export const DISCOUNT_ROUTE = `${STOCK_ROUTE}/${DISCOUNT_PAGE}` as const;
export const CATALOG_ROUTE = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.catalog];
export const CART_ROUTE = CART_ROUTE_TO_URL;
export const COOKIES_POLICY_ROUTE = `${HOME_ROUTE}${COOKIES_POLICY_PAGE}/` as const;
export const SEO_CATALOG_ROUTE = `${CATALOG_ROUTE}/${SEO_CATALOG_PAGE}` as const;
export const SEARCH_ROUTE = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.search];
export const PERSONAL_DATA_PROCESSING_ROUTE = `${NEXT_PUBLIC_MASTER_HOST}/${PERSONAL_DATA_PROCESSING_PAGE}` as const;
export const PERSONAL_DATA_PROCESSING_ROUTE_AUTH =
    `${NEXT_PUBLIC_MASTER_HOST}/${PERSONAL_DATA_PROCESSING_PAGE_AUTH}` as const;
export const PRIVACY_POLICY_ROUTE = `${NEXT_PUBLIC_MASTER_HOST}/${PRIVACY_POLICY_PAGE}` as const;
export const RECOMMENDATION_TECHNOLOGIES_ROUTE = `${HOME_ROUTE}${RECOMMENDATION_TECHNOLOGIES_PAGE}/`;
export const TERMS_ROUTE = `${NEXT_PUBLIC_MASTER_HOST}/${TERMS_PAGE}` as const;
export const PRODUCT_ROUTE = `${HOME_ROUTE}${PRODUCT_PAGE}` as const;
export const SERVICE_ROUTE = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.services];
export const WINESHOPS_LIST_ROUTE = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.addresses];
export const BRANDS_ROUTE = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.brands];
export const ARTICLES_ROUTE = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.articles];
export const EVENTS_ROUTE = `${APP_ROUTES_TO_URL[APP_ROUTES_KEYS.events]}/`;

export const DASHBOARD_ROOT_ROUTE = `${HOME_ROUTE}${DASHBOARD_PAGE}` as const;
export const DASHBOARD_CARD_ROUTE = `${DASHBOARD_ROOT_ROUTE}/cards` as const;
export const DASHBOARD_ORDERS_ROUTE = `${DASHBOARD_ROOT_ROUTE}/orders` as const;
export const DASHBOARD_RETURNS_ROUTE = `${DASHBOARD_ORDERS_ROUTE}/returns` as const;
export const DASHBOARD_PROFILE_ROUTE = `${DASHBOARD_ROOT_ROUTE}/profile` as const;
export const DASHBOARD_PROFILE_ADDRESS_ROUTE = `${DASHBOARD_PROFILE_ROUTE}/address` as const;
export const DASHBOARD_PROFILE_SOCIAL_ROUTE = `${DASHBOARD_PROFILE_ROUTE}/social` as const;

export const LOGOUT_ROUTE = `${HOME_ROUTE}logout` as const;
export const SALE_LINK = 'https://simplewine.ru/stock/discount/' as const;
export const CART_LINK = 'https://simplewine.ru/personal/cart/' as const;
export const PERSONAL_LK_LINK = `${HOME_ROUTE}${PERSONAL_PAGE}/?lk_tabs=lk` as const;
export const WISHLIST_LINK = `/${PERSONAL_PAGE}/${WISHLIST_PAGE}/` as const;
export const REVIEW_MODERATION_RULES_ROUTE = `${ARTICLES_ROUTE}/news/pravila-moderatsii-otzyvov/` as const;

export const SYSTEM_CATALOG_PAGE_ROUTE = `${CATALOG_ROUTE}/[${ROUTER_QUERY_KEY}]` as const;
export const SYSTEM_CATALOG_TAG_PAGE_ROUTE =
    `${SYSTEM_CATALOG_PAGE_ROUTE}/[${ROUTER_QUERY_TAG_OR_COLLECTION_KEY}]` as const;
export const SYSTEM_CATALOG_COLLECTIONS_PAGE = `${SYSTEM_CATALOG_PAGE_ROUTE}/${COLLECTIONS_LIST_PAGE}` as const;

// TODO: При разрастании поменять на хеш-таблицу, в которой по ключу path будут лежать объекты
export const PAGES = {
    ADDRESSES_PAGE: {
        path: WINESHOPS_LIST_ROUTE,
        title: 'Винотеки',
    },
    ARTICLES_PAGE: {
        path: ARTICLES_ROUTE,
        title: 'Интересно о вине',
    },
    BRANDS_PAGE: {
        path: BRANDS_ROUTE,
        title: 'Бренды',
    },
    CATALOG_PAGE: {
        path: CATALOG_PAGE,
        title: 'Каталог',
    },
    COOKIES_POLICY_PAGE: {
        path: COOKIES_POLICY_PAGE,
        title: 'Политика cookies',
        url: COOKIES_POLICY_ROUTE,
    },
    DASHBOARD_ORDERS: {
        path: DASHBOARD_ORDERS_ROUTE,
        title: 'Заказы и возвраты',
    },
    DASHBOARD_PROFILE_PAGE: {
        path: DASHBOARD_PAGE,
        title: 'Мой профиль',
    },
    DISCOUNT_PAGE: {
        path: DISCOUNT_PAGE,
        title: 'Все скидки',
        url: DISCOUNT_ROUTE,
    },
    EVENTS_PAGE: {
        path: EVENTS_ROUTE,
        title: 'Мероприятия с дегустацией',
    },
    HOME_PAGE: {
        path: HOME_ROUTE,
        title: 'Главная',
    },
    PERSONAL_DATA_PROCESSING_PAGE: {
        path: PERSONAL_DATA_PROCESSING_PAGE,
        title: 'Политика обработки персональных данных',
        url: PERSONAL_DATA_PROCESSING_ROUTE,
    },
    PRIVACY_POLICY_PAGE: {
        path: PRIVACY_POLICY_PAGE,
        title: 'Согласие на обработку персональных данных',
        url: PRIVACY_POLICY_ROUTE,
    },
    RECOMMENDATION_TECHNOLOGIES_PAGE: {
        path: RECOMMENDATION_TECHNOLOGIES_PAGE,
        title: 'Правила применения рекомендательных технологий',
        url: RECOMMENDATION_TECHNOLOGIES_ROUTE,
    },
    SEARCH_PAGE: {
        path: SEARCH_PAGE,
        title: 'Поиск',
        url: SEARCH_ROUTE,
    },
    SEO_CATALOG_PAGE: {
        path: SEO_CATALOG_PAGE,
        title: 'Каталог товаров',
        url: SEO_CATALOG_ROUTE,
    },
    SERVICE_PAGE: {
        path: SERVICE_PAGE,
        title: 'Сервисы и услуги',
        url: SERVICE_ROUTE,
    },
    STOCK_PAGE: {
        path: DISCOUNT_PAGE,
        title: 'Все акции',
        url: DISCOUNT_ROUTE,
    },
    PERSONAL_PAGE: {
        path: PERSONAL_PAGE,
        title: 'Личный кабинет',
        url: PERSONAL_LK_LINK,
    },
    PERSONAL_WISHLIST_PAGE: {
        path: WISHLIST_PAGE,
        title: 'Список желаний',
        url: WISHLIST_LINK,
    },
    PRODUCT_REVIEWS_PAGE: {
        path: PRODUCT_REVIEWS_PAGE,
        title: 'Отзывы',
        url: '',
    },
} as const;
